export default __webpack_public_path__ + "static/expressive-55148377aaaa4f434193450f96f81be7.mp4";